module.exports = __webpack_public_path__ + "img/CARAC2.519c2869.jpg";